module.exports = __webpack_public_path__ + "static/media/rede-fundo-caminhao.c12d58cc.jpg";